module.exports = __webpack_public_path__ + "img/Us-bangla.7df3fb9c.jpg";